import { render, staticRenderFns } from "./addNewProblemModal.vue?vue&type=template&id=d89fc2e4&scoped=true&"
import script from "./addNewProblemModal.vue?vue&type=script&lang=js&"
export * from "./addNewProblemModal.vue?vue&type=script&lang=js&"
import style0 from "./addNewProblemModal.vue?vue&type=style&index=0&id=d89fc2e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89fc2e4",
  null
  
)

export default component.exports